<!--
 * @Author: Gaho
 * @Date: 2024-03-19 13:25:07
 * @LastEditors: Gaho
 * @LastEditTime: 2024-06-21 13:24:45
 * @Description: 
-->
<template>
    <div class="relative py-4">
        <TripleGameContent 
            :randomSeed="randomSeed" 
            :tableArray="tableArraySelected" 
            class="!m-0"
        />
    </div>
</template>
<script setup lang="ts">
import TripleGameContent from '@/pages/casino/tripleGame/_components/gameContent/index.vue';
import { tableArray } from '@/pages/casino/tripleGame/data/index';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';

const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
    },
});
const randomSeed = ref([]);
const tableArraySelected = ref(tableArray);

onMounted(() => {
    console.log(props.history, 'history-triple');
    randomSeed.value = [];
    tableArraySelected.value = tableArraySelected.value.map(item => ({
        ...item,
        status: ''
    }));
    initData();
})
const initData = () => {
    const { randomSeed: randomSeeds, selected } = props.history;
    randomSeed.value = randomSeeds.split('_')[0].split(',');
    selected.forEach((item) => {
        tableArraySelected.value[item].status = 'selected';
    })
}
</script>